var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-end"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"margin":"1em"},on:{"click":_vm.deleteRow}},[_vm._v(" Afwezigheid Verwijderen ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }